import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-profile-image-manager',
  templateUrl: './profile-image-manager.component.html',
  styles: ``
})
export class ProfileImageManagerComponent implements OnInit {
  @Input() maxFileSize = 10;
  @Input() isDisabled = false;
  @Input() managerIndex: any = '0'; // For input id multi file manager in one view
  @Input() label!: string;
  @Input() defualtImage!: string;


  @Output() onImageChanged = new EventEmitter();

  SelectedImage!: string
  fileMaxSiZeErorr: boolean = false;
  validFile: boolean = true;
  allowedExt: any[] = ['png', 'jpg', 'jpeg']
  constructor() {

  }
  ngOnInit(): void {

  }



  fileBrowseHandler(event: any) {
    this.fileMaxSiZeErorr = false;
    this.validFile = true;
    const file = event.target.files[0];
    if (this.validFileType(file.name)) {
      this.validFile = true;
    } else {
      this.validFile = false;
      return;
    }
    if (file?.size / (1024 * 1024) > this.maxFileSize) {
      this.fileMaxSiZeErorr = true
      return;
    } else {
      this.convertFileToBase64(file, (base64: any) => {
        this.SelectedImage = base64;
      })
      this.onImageChanged.emit(file);
    }
  }


  convertFileToBase64(file: any, callback: any) {
    const reader = new FileReader();

    reader.onload = function (event: any) {
      const base64String = event.target.result;
      callback(base64String);
    };

    reader.readAsDataURL(file);

  }


  validFileType(fileName: string) {
    const extension = fileName.split('.').pop()?.toLowerCase();
    const extensionUpper = fileName.split('.').pop()?.toUpperCase();
    if (!(this.allowedExt.includes(extension) || this.allowedExt.includes(extensionUpper))) {
      return false;
    }
    return true;
  }
}
